<div loadingblock>
  <div *ngFor="let row of toArray(rows)" class="flex gap-[1vw] w-4/5 mx-auto mt-[2vw] mobile:hidden">
    <p *ngFor="let row of toArray(columns)" picblock></p>
  </div>

  <p *ngFor="let row of toArray(columns)" picblock class="desktop:hidden m-3 !pb-[37%]"></p>
</div>